import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Box from "@mui/material/Box";
import { useConfigurationGroupScrolling } from "../../NavigationState/useConfigurationScrolling";
import { AttributeGroupHeadline } from "./AttributeGroupHeadline";
export function AttributeGroupSimple(props) {
    const groupRef = useConfigurationGroupScrolling({ groupId: props.title });
    return (_jsxs(Box, { ref: groupRef, sx: { my: "1em" }, className: "attribute-group-simple", children: [_jsx(AttributeGroupHeadline, Object.assign({}, props)), props.children] }));
}
//# sourceMappingURL=AttributeGroupSimple.js.map